export default "__VITE_ASSET__DkrFRzno__"